/**
 * @generated SignedSource<<b84a87058355370ad236432e3143f913>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useUserPrompts_query$data = {
  readonly currentUser: {
    readonly userPrompts: {
      readonly nodes: ReadonlyArray<{
        readonly answer: string;
        readonly prompt: {
          readonly deletedAt: any | null | undefined;
          readonly question: string;
        } | null | undefined;
        readonly promptId: any;
      } | null | undefined>;
    };
  } | null | undefined;
  readonly " $fragmentType": "useUserPrompts_query";
};
export type useUserPrompts_query$key = {
  readonly " $data"?: useUserPrompts_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"useUserPrompts_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useUserPrompts_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "currentUser",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "orderBy",
              "value": [
                "SEQUENCE_ASC"
              ]
            }
          ],
          "concreteType": "UserPromptConnection",
          "kind": "LinkedField",
          "name": "userPrompts",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "UserPrompt",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "promptId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "answer",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Prompt",
                  "kind": "LinkedField",
                  "name": "prompt",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "question",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "deletedAt",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "userPrompts(orderBy:[\"SEQUENCE_ASC\"])"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "a3d346e9552305b08d20c48c5ab50bb9";

export default node;
